module.exports = {
    encode: require('./encode.js')
  , decode: require('./decode.js')
  , encodingLength: require('./length.js')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/varint/index.js
// module id = u1y2
// module chunks = 0